import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";

export default function BigCommerce() {
  return (
    <div className="Big-Commerce pt-[160px] sm:pt-0">
      <Helmet>
        <title>Top BigCommerce Development Agency in Dubai | Mean3</title>
        <meta
          name="description"
          content="Boost your e-commerce store with expert BigCommerce services in Dubai. Drive growth with custom solutions. Get started today!"
        />
      </Helmet>      
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
    </div>
  );
}
